define([
	"dojo/query"
], function(query) {

	function isWord(str) {
		return /^\w+$/.test(str);
	}

	function addChildrenToArray(arr, node) {
		// summary: add children nodes to the array ignoring all nodes except element nodes
		var children = node.childNodes;
		for (var i=0; i < children.length; i++) {
			var childNode = children[i];
			if (childNode.nodeType == 1)
				arr.push(childNode);
		}
	}

	function addChildrenWithTagName(arr, node, tagName1, tagName2) {
		// summary: add children nodes to the array if their tag names are equal to 'tagName1' or 'tagName2'
		var children = node.childNodes;
		for (var i=0; i < children.length; i++) {
			var childNode = children[i];
			if (childNode.nodeType == 1 && (childNode.tagName == tagName1 || childNode.tagName == tagName2))
				arr.push(childNode);
		}
	}

	function addChildrenWithTagNameAndAttributeValue(arr, node, tagName, attrId, attrValue) {
		// summary: add children nodes to the array if
		// their tag names are equal to 'tagName' and attribute with id 'attrId' equals to 'attrValue'
		var children = node.childNodes;
		for (var i=0; i < children.length; i++) {
			var childNode = children[i];
			if (childNode.nodeType == 1 && childNode.tagName == tagName && childNode.getAttribute(attrId) == attrValue)
				arr.push(childNode);
		}
	}

	function throwXPathError(xpath,message) {
		throw new Error("XPath '"+xpath+"' is not supported. "+message);
	}

	return {
		selectNodes: function(contextNode, xpath) {
			// summary: select nodes using XPath syntax, but without XPath engine
			// It supports just some very basic features of XPath:
			//   //<tagName>[@attr="value"]
			//   /<tagName1>/<tagName2>[@attr="value"]
			//   child::*
			//   <tagName>
			//   <tagName>/child::*
			//   <tagName1>/<tagName2>
			//   <tagName>[@attr="value"]
			//   <tagName1>|<tagName2>

			var result;
			if (xpath.charAt(0) == '/') {
				// if starts with the slash, we can use CSS selection engine
				// It covers options:
				//   //<tagName>[@attr="value"]
				//   /<tagName1>/<tagName2>[@attr="value"]

				var cssSelectors = xpath
			        .replace(/^\/+/, "")			// remove leading slashes - not needed
			        .replace(/\/+/g, ">")			// convert '/' to a child combinator
			        .replace(/@/g, "");				// attribute reference doesn't have a leading '@' in CSS

			    result = query(cssSelectors, contextNode);
			} else {
				result = [];
				if (xpath == "child::*") {
					// only 'child::*'
					addChildrenToArray(result, contextNode);
				} else if(isWord(xpath)) {
					// <tagName>
					addChildrenWithTagName(result, contextNode, xpath);
				} else {
					// try to process two-step path
					var steps = xpath.split("/");
					if (steps.length > 2)
						throwXPathError(xpath,"Only 2 steps allowed");

					if (steps.length == 2) {
						// Process options <tagName>/child::* and <tagName1>/<tagName2>.
						if (!isWord(steps[0]))
							throwXPathError(xpath,"First step must be a tag name");

						var firstStepNodes = [];
						addChildrenWithTagName(firstStepNodes, contextNode, steps[0]);

						if (steps[1] == "child::*") {
							for (var i=0; i < firstStepNodes.length; i++) {
								addChildrenToArray(result, firstStepNodes[i]);
							}
						} else {
							if (!isWord(steps[1]))
								throwXPathError(xpath,"Second step must be a tag name or 'child::*'");

							for (var i=0; i < firstStepNodes.length; i++) {
								addChildrenWithTagName(result, firstStepNodes[i], steps[1]);
							}
						}
					} else {
						// Let's try to process option '<tagName1>|<tagName2>' first - OR condition of two tag names
						var steps = xpath.split("|");
						if (steps.length > 2)
							throwXPathError(xpath,"Only 2 tag names in '|' condition are allowed");

						if (steps.length == 2) {
							if (!isWord(steps[0]))
								throwXPathError(xpath,"First condition must be a tag name");

							if (!isWord(steps[1]))
								throwXPathError(xpath,"Second condition must be a tag name");

							addChildrenWithTagName(result, contextNode, steps[0], steps[1]);
						} else {
							// The last option - <tagName>[@attr="value"]

							// Extract a tag name, attribute id and attribute value
							var match = /^(\w+)\[@(\w+)="(.+)"\]$/.exec(xpath);
							if (!match)
								throwXPathError(xpath,"");

							var tagName = match[1];
							var attrId = match[2];
							var attrValue = match[3];

							addChildrenWithTagNameAndAttributeValue(result, contextNode, tagName, attrId, attrValue);
						}
					}
				}
			}

		    return result;
		}
	};
});